import React, { useEffect, useRef, useState } from "react";
import newimage from "../../Assets/profileimage.jpeg";

/* Theme  : same as Our Approach page.
            text #4e5356 | buttons #2596be | headings #4573a6
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body)
   Layout : text left, arch-shaped image right, 3 stats cards below. */

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.ceo{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;padding:90px 24px;
background: #ffffff;
  display:flex;flex-direction:column;align-items:center;
  font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.ceo::before {
  content: none;
}
    background-image:radial-gradient(rgba(69,115,166,.12) 1.2px,transparent 1.2px);background-size:26px 26px;
  -webkit-mask-image:linear-gradient(180deg,#000,transparent 65%);mask-image:linear-gradient(180deg,#000,transparent 65%)}
.ceo>*{position:relative;z-index:1}

/* ---------- TOP ---------- */
.ceo-top{display:flex;align-items:center;justify-content:space-between;gap:70px;max-width:1150px;width:100%}
.ceo-text{flex:1;min-width:0;max-width:560px;animation:ceoFromL .9s cubic-bezier(.2,.8,.2,1) backwards}

/* chip = same as .op-chip */
.ceo-label{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:#fff;border:1px solid var(--line);
  color:var(--head);font-family:"Open Sans",sans-serif;font-weight:400;font-size:12px;letter-spacing:2px;text-transform:uppercase}

/* name = same as .op-head h2 (Ubuntu Bold 42px, --head, hover --btn) */
.ceo-name{display:inline-block;margin:0 0 12px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;
  color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.ceo-name:hover{color:var(--btn);letter-spacing:.6px}

.ceo-role{display:flex;align-items:center;gap:12px;margin:22px 0 18px}
.ceo-role i{width:40px;height:3px;border-radius:2px;background:linear-gradient(90deg,var(--head),var(--btn))}
/* role = same as card h3 (Ubuntu Bold 20px, --head) */
.ceo-role h2{margin:0;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}

/* body = same as .op-card p (Open Sans 14.5px, 1.75, --text) */
.ceo-text p{margin:0 0 24px;font-family:"Open Sans",sans-serif;font-weight:400;font-size:14.5px;line-height:1.75;color:var(--text);max-width:510px}

.ceo-tags{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:30px}
.ceo-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-family:"Open Sans",sans-serif;font-size:14px;font-weight:600;cursor:pointer;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.ceo-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));
  transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.ceo-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.ceo-tag:hover::before{transform:none}

/* button = same as .op-btn */
.ceo-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:11px 24px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-size:14px;font-weight:600;cursor:pointer;
  transition:color .35s,box-shadow .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.ceo-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));
  transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.ceo-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 16px 26px -12px rgba(37,150,190,.7)}
.ceo-btn:hover::before{transform:none}
.ceo-btn svg{transition:transform .35s}
.ceo-btn:hover svg{transform:rotate(-12deg) scale(1.12)}

/* ---------- IMAGE ---------- */
.ceo-imgwrap{position:relative;flex:none;width:360px;height:440px;margin-right:50px;animation:ceoFromR .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.ceo-ring{position:absolute;inset:-16px;border-radius:200px 200px 40px 40px;overflow:hidden}
.ceo-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:ceoSpin 8s linear infinite}
.ceo-ring::after{content:"";position:absolute;inset:4px;border-radius:196px 196px 36px 36px;background:#eef6fa}
.ceo-tilt{position:absolute;inset:0;transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.ceo-tilt img{width:100%;height:100%;object-fit:cover;object-position:top;display:block;border-radius:190px 190px 30px 30px;
  box-shadow:0 30px 50px -24px rgba(69,115,166,.6)}

.ceo-chip{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;
  background:rgba(255,255,255,.95);backdrop-filter:blur(8px);border:1px solid var(--line);
  box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.ceo-chip b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.ceo-chip .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:14px;
  background:linear-gradient(135deg,var(--head),var(--btn))}
.ceo-chip.c1{left:-46px;bottom:50px;animation:ceoFloat 5s ease-in-out infinite}
.ceo-chip.c2{right:-70px;top:255px;animation:ceoFloat 6s -2s ease-in-out infinite}

/* ---------- STATS ---------- */
.ceo-stats{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:22px;max-width:1000px;width:100%;margin-top:80px}
.ceo-stats:not(.in) .ceo-card{opacity:0}
.ceo-stats.in .ceo-card{animation:ceoRise .8s cubic-bezier(.2,.8,.2,1) backwards;animation-delay:calc(var(--i) * .13s)}

.ceo-card{--mx:50%;--my:50%;position:relative;overflow:hidden;display:flex;align-items:center;gap:18px;padding:24px 26px;border-radius:24px;
  background:#fff;border:1px solid var(--line);box-shadow:0 12px 26px -20px rgba(69,115,166,.55);cursor:default;
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s}
.ceo-card:hover{transform:translateY(-8px);border-color:rgba(37,150,190,.5);box-shadow:0 34px 56px -26px rgba(37,150,190,.6),0 0 0 4px rgba(37,150,190,.07)}
.ceo-card .glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(240px circle at var(--mx) var(--my),rgba(37,150,190,.16),rgba(69,115,166,.05) 45%,transparent 70%)}
.ceo-card:hover .glow{opacity:1}
.ceo-card .bar{position:absolute;top:0;left:0;height:5px;width:100%;background:linear-gradient(90deg,var(--head),var(--btn));
  transform:scaleX(0);transform-origin:left;transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.ceo-card:hover .bar{transform:scaleX(1)}
.ceo-ico{position:relative;flex:none;width:58px;height:58px;border-radius:16px;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(135deg,var(--head),var(--btn));box-shadow:0 12px 22px -10px rgba(69,115,166,.7);
  transition:transform .5s cubic-bezier(.3,1.6,.5,1)}
.ceo-card:hover .ceo-ico{transform:rotate(-8deg) scale(1.1)}
/* stat title = card h3 style, subtitle = card p style */
.ceo-card .t{position:relative;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;line-height:1.2;color:var(--head)}
.ceo-card .s{position:relative;margin-top:3px;font-family:"Open Sans",sans-serif;font-weight:400;font-size:14.5px;color:var(--text)}

@keyframes ceoFromL{from{opacity:0;transform:translateX(-70px)}}
@keyframes ceoFromR{from{opacity:0;transform:translateX(70px)}}
@keyframes ceoRise{from{opacity:0;transform:translateY(50px)}}
@keyframes ceoSpin{to{transform:rotate(360deg)}}
@keyframes ceoFloat{50%{transform:translateY(-12px)}}

@media(max-width:960px){
  .ceo{padding:70px 18px}
  .ceo-top{flex-direction:column-reverse;gap:64px}
  .ceo-text{max-width:100%}
  .ceo-imgwrap{width:300px;height:370px;margin-right:0}
  .ceo-chip.c1{left:-14px;bottom:50px}
  .ceo-chip.c2{right:-14px;top:auto;bottom:-24px}
  .ceo-stats{grid-template-columns:1fr;margin-top:60px}
}
@media(max-width:600px){.ceo-name{font-size:30px}}
@media(prefers-reduced-motion:reduce){
  .ceo *,.ceo *::before,.ceo *::after{animation:none!important;transition:none!important}
  .ceo-stats .ceo-card{opacity:1}
}
`;

/* counts from 0 to `to` once, when `start` becomes true */
const useCountUp = (to: number, start: boolean, ms = 1400) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf = 0;
    const t0 = performance.now();
    const tick = (now: number) => {
      const p = Math.min((now - t0) / ms, 1);
      setVal(Math.round((1 - Math.pow(1 - p, 3)) * to));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, start, ms]);
  return val;
};

type StatProps = {
  index: number;
  icon: React.ReactNode;
  subtitle: string;
  start: boolean;
  count?: number;
  suffix?: string;
  plain?: string;
};

const Stat = ({ index, icon, subtitle, start, count, suffix, plain }: StatProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const n = useCountUp(count ?? 0, start && count !== undefined);

  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", e.clientX - r.left + "px");
    el.style.setProperty("--my", e.clientY - r.top + "px");
  };

  return (
    <div className="ceo-card" ref={ref} onMouseMove={handleMove} style={{ ["--i" as any]: index }}>
      <div className="bar" />
      <div className="glow" />
      <div className="ceo-ico">{icon}</div>
      <div>
        <div className="t">{plain ?? `${n}${suffix ?? ""}`}</div>
        <div className="s">{subtitle}</div>
      </div>
    </div>
  );
};

const OurCeo = () => {
  const tiltRef = useRef<HTMLDivElement | null>(null);
  const statsRef = useRef<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);

  // stats appear + count up when scrolled into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect(); } },
      { threshold: 0.25 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  // gentle 3D tilt on the photo
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 12;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -12;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div className="ceo">
      <style>{STYLES}</style>

      <div className="ceo-top">
        {/* TEXT */}
        <div className="ceo-text">
          <span className="ceo-label">Meet Our Leader</span>

          <div>
            <h1 className="ceo-name">Atul Walhekar</h1>
          </div>

          <div className="ceo-role">
            <i />
            <h2>MD &amp; COO</h2>
          </div>

          <p>
            Atul Walhekar, as Managing Director and COO, has led the company
            with strategic foresight and operational excellence. His dedication
            and expertise have driven innovation and growth, keeping the company
            ahead in a dynamic market. Under his leadership, the company has
            achieved major milestones and set new industry standards.
          </p>

          <div className="ceo-tags">
            <span className="ceo-tag">Strategy</span>
            <span className="ceo-tag">Operations</span>
            <span className="ceo-tag">Innovation</span>
          </div>

          <button className="ceo-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.9 13.88 19.79 19.79 0 011.88 5.26 2 2 0 013.88 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 17.92z" />
            </svg>
            Contact
          </button>
        </div>

        {/* IMAGE */}
        <div className="ceo-imgwrap" onMouseMove={handleMove} onMouseLeave={handleLeave}>
          <div className="ceo-ring" />
          <div className="ceo-tilt" ref={tiltRef}>
            <img src={newimage} alt="Atul Walhekar - MD & COO" />
          </div>

          <div className="ceo-chip c1">
            <span className="dot">★</span>
            <div>Leadership<b>MD &amp; COO</b></div>
          </div>
          <div className="ceo-chip c2">
            <span className="dot">12</span>
            <div>Experience<b>12+ Years</b></div>
          </div>
        </div>
      </div>

      {/* STATS */}
      <div className={"ceo-stats" + (inView ? " in" : "")} ref={statsRef}>
        <Stat
          index={0}
          start={inView}
          count={12}
          suffix="+ Years"
          subtitle="Experience"
          icon={
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <circle cx="12" cy="8" r="4" />
              <path d="M20 21a8 8 0 00-16 0" />
              <path d="M16 11l1.5 1.5L21 9" />
            </svg>
          }
        />
        <Stat
          index={1}
          start={inView}
          count={100}
          suffix="+ Projects"
          subtitle="Completed"
          icon={
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <path d="M8 21h8M12 17v4" />
              <path d="M7 8l3 3 5-5" />
            </svg>
          }
        />
        <Stat
          index={2}
          start={inView}
          plain="24/7 Support"
          subtitle="Always Online"
          icon={
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
              <circle cx="9" cy="10" r="1" fill="#fff" />
              <circle cx="12" cy="10" r="1" fill="#fff" />
              <circle cx="15" cy="10" r="1" fill="#fff" />
            </svg>
          }
        />
      </div>
    </div>
  );
};

export default OurCeo;